import * as React from 'react'
import { ReplyMessageCardConnected } from './ReplyMessageCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_MESSAGE_A_ID } from 'mockState'

export const ReplyMessageCardExamples = () => {
  return (
    <div className="ReplyMessageCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ReplyMessageCardConnected messageId={MOCK_MESSAGE_A_ID} />
      </Provider>
    </div>
  )
}
